<script>
import AuthLayout from '@layouts/auth.vue'

export default {
  page: {
    title: 'Instrukcijos išsiųstos!',
  },

  components: { AuthLayout },
}
</script>

<template>
  <AuthLayout>
    <template v-slot:title> Instrukcijos išsiųstos! </template>

    <p class="mb-2 text-justify text-sm">
      Į nurodytą pašto adresą buvo išsiustas el. laiškas su slaptažodžio keitimo
      instrukcijomis.
    </p>

    <p class="text-justify text-sm">
      Jeigu per artimiausias 5 minutes negavote laiško - pasitikrinkite gal jis
      nukeliavo į šlamšto (angl. „spam“) katalogą.
    </p>

    <div class="mt-8 text-center font-medium text-sm">
      <router-link :to="{ name: 'login' }"> Prisijungimas </router-link>
    </div>
  </AuthLayout>
</template>
